import React from 'react'
import image0 from './components/images/home/0.jpg'
import image1 from './components/images/home/1.jpg'
import image2 from './components/images/home/2.jpg'
import image3 from './components/images/home/3.jpg'
import image4 from './components/images/home/4.jpg'
import image5 from './components/images/home/5.jpg'
import image6 from './components/images/home/6.jpg'
import image7 from './components/images/home/7.jpg'
import image8 from './components/images/home/8.png'
import { Link } from "react-router-dom";

import './HomeCarousel2.css'
function HomeCarousel2() {
    return (
        <div className='carouselBody'>
            <div class="slider">
                <div class="slide-track">

                    {/* 9 slides */}
                    <a href="/Betrayal-At-House-3rd-Edition"> 
                    <div class="slide">
                        <img src={image0} ></img>

                    </div></a>
                   
                    <a href="/Cards-Against-Humanity"> 
                    <div class="slide">
                        <img src={image1} ></img>

                    </div></a>


                    <a href="/Munchkin-Deluxe"> 
                    <div class="slide">
                        <img src={image2} ></img>

                    </div></a>

                    <a href="/Munchkin-Deluxe"> 
                    <div class="slide">
                        <img src={image7} ></img>

                    </div></a>

                    <a href="/Red-Dragon-Inn"> 
                    <div class="slide">
                        <img src={image3} ></img>

                    </div></a>
                  
                    <a href="/Escape-The-Dark-Castle"> 
                    <div class="slide">
                        <img src={image4} ></img>

                    </div></a>



                    <a href="/Sushi-Go"> 
                    <div class="slide">
                        <img src={image5} ></img>

                    </div></a>

                    <a href="/Sushi-Go"> 
                    <div class="slide">
                        <img src={image8} ></img>

                    </div></a>
                    <a href="/Catan"> 
                    <div class="slide">
                        <img src={image6} ></img>

                    </div></a>
                    <a href="/Betrayal-At-House-3rd-Edition"> 
                    <div class="slide">
                        <img src={image0} ></img>

                    </div></a>
                    
                    <a href="/Cards-Against-Humanity"> 
                    <div class="slide">
                        <img src={image1} ></img>

                    </div></a>


                    <a href="/Munchkin-Deluxe"> 
                    <div class="slide">
                        <img src={image2} ></img>

                    </div></a>

                    <a href="/Munchkin-Deluxe"> 
                    <div class="slide">
                        <img src={image7} ></img>

                    </div></a>

                    <a href="/The-Red-Dragon-Inn"> 
                    <div class="slide">
                        <img src={image3} ></img>

                    </div></a>
                  
                    <a href="/Escape-The-Dark-Castle"> 
                    <div class="slide">
                        <img src={image4} ></img>

                    </div></a>



                    <a href="/Sushi-Go"> 
                    <div class="slide">
                        <img src={image5} ></img>

                    </div></a>

                    <a href="/Catan"> 
                    <div class="slide">
                        <img src={image6} ></img>

                    </div></a>
                    <a href="/Sushi-Go"> 
                    <div class="slide">
                        <img src={image8} ></img>

                    </div></a>
                </div>
            </div>
        </div>

    )
}

export default HomeCarousel2
